import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/events/streams';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/event/streams`,
      { headers: getLocalUser() }
    );
    // core wraps payloads under { data: ... }
    const body = response?.data?.data ?? response?.data ?? {};
    yield put(fetchSuccess(body.streams || []));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
